import React, {Fragment, useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";

import GroheFeaturesTotalPrice from "./groheFeaturesTotalPrice";
import GroheRequiredFeaturesSlider from "./groheRequiredFeaturesSlider";
import WithUpdateCartItems from "../../../hocs/withUpdateCartItems";
import {setLookActiveCategory} from "../../../../../actions/lookFunctions";
import {getCartItemsArrayFromFeature, getFeatureUrl} from "../../../lookNavigation/lookFunctions2";
import {withRouter} from "react-router-dom";
import {setGroheRequiredButNotIncludedFeature} from "../../../../../actions/groheFunctions";
import WithAddToCartPostMessage from "../../../hocs/withAddToCartPostMessage";

const GroheRequiredFeatures = (props) => {
  const {requiredFeatures, setLookActiveCategory, lookActiveFeature, history, setGroheRequiredButNotIncludedFeature,
    qtActiveCategory} = props;

  const [addedToCartClicked, setAddedToCartClicked] = useState(false);

  if (!requiredFeatures) {
    return null
  }

  const addAllToCartButtonClick = (updateCartItems, addToCartPostMessage) => {
    updateCartItems(requiredFeatures);
    let cartItemsArray = [];
    requiredFeatures.forEach(requiredFeature => {
      return cartItemsArray = [...cartItemsArray, ...getCartItemsArrayFromFeature(requiredFeature, 1, qtActiveCategory)]
    })
    addToCartPostMessage(cartItemsArray);
    setAddedToCartClicked(true);
  };

  const viewAllButtonClick = () => {
    setLookActiveCategory("");
    setGroheRequiredButNotIncludedFeature(lookActiveFeature);
    history.push(getFeatureUrl(lookActiveFeature, true));
  };

  const getCartButtonText = () => {
    if (addedToCartClicked) {
      return <FormattedMessage id={requiredFeatures.length > 1 ? "grohe.feature.addedToCartAll" : "grohe.feature.addedToCart"}/>
    }
    if (requiredFeatures.length > 1) {
      return (
        <Fragment>
          <FormattedMessage id={"grohe.feature.addAllToCartButton"}/> ({requiredFeatures.length})
        </Fragment>
      )
    }
    return <FormattedMessage id={"grohe.feature.addToCartButton"}/>
  }

  return (
    <div className="required-feature">
      <div className="required-feature__description">
        <span>
          <FormattedMessage id="grohe.feature.relatedItems" />
        </span>
        <span>
          <GroheFeaturesTotalPrice features={requiredFeatures}/>
        </span>
      </div>
      <GroheRequiredFeaturesSlider requiredFeatures={requiredFeatures}/>
      <div className="related-buttons">
        <div className="grohe-feature__button related-buttons__button">
          <WithUpdateCartItems>
            {(updateCartItems) => (
              <WithAddToCartPostMessage>
              {(addToCartPostMessage) => (
                <Button
                  className={"look-button look-button--small grohe-look__button--small grohe-look__button--secondary"}
                  onClick={() => addedToCartClicked ? null : addAllToCartButtonClick(updateCartItems, addToCartPostMessage)}
                  disabled={addedToCartClicked}>
                  {getCartButtonText()}
                </Button>
              )}
              </WithAddToCartPostMessage>
            )}
          </WithUpdateCartItems>
        </div>
        <div className="grohe-feature__button related-buttons__button">
          <Button className={"look-button look-button--small grohe-look__button--small grohe-look__button--secondary"}
                  onClick={viewAllButtonClick}>
            <FormattedMessage id={requiredFeatures.length > 1 ? "grohe.feature.viewAll" : "grohe.feature.view"}/>
          </Button>
        </div>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature} = store.lookState;
  const {qtActiveCategory} = store.qtState;

  return {
    lookActiveFeature,
    qtActiveCategory,
  }
};

const mapDispatchToProps = {
  setLookActiveCategory,
  setGroheRequiredButNotIncludedFeature,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(GroheRequiredFeatures)
);
